import React, { useEffect, useState } from "react"
import { Row, Col, Container,  Card } from "react-bootstrap"
import Accordion from "react-bootstrap/Accordion"
import HTMLReactParser from 'html-react-parser';

import "./Faq.scss"

// Header component

const FAQ = ({Module}) => {
    const [activeId, setActiveId] = useState("0");

    function toggleActive(id) {
        if (activeId === id) {
        setActiveId("")
        } else {
        setActiveId(id)
        }
    }

    //console.log("Module ===>", Module);
    return (
        <React.Fragment>

            <section className={`accordion-wrapper ${Module.theme}`}>
                <div className="accordion-section">
                    {Module.title && <h3>{Module.title}</h3> }

                    <Accordion defaultActiveKey={activeId}>
                        {
                            Module.faq.length > 0 && Module.faq.map((item, index) => {
                                return(
                                    <Accordion.Item eventKey={index.toString()}>
                                        <Accordion.Header>{item.question}</Accordion.Header>
                                        <Accordion.Body>
                                            {item.answer && HTMLReactParser(item.answer)}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                )
                            })
                        }
                    </Accordion>
                </div>
            </section>
        </React.Fragment>
    );
};
export default FAQ;

